import React from "react";
import { LeadStatusHistoryLog } from "../../../../types/HistoryLog";
import { translate } from "../../../../services/Translations/translatorService";
import { ArrowRightAlt } from "@mui/icons-material";
import GenericLogEntry from "../GenericLogEntry";
import _ from "lodash";
import { getStageList } from "../../../../services/Product/ProductService/productService";
import { cloneHistoryLogAsGeneric } from "../../../../services/historyService";

import { ProductUnion } from "../../../../types/ProductUnion";

type CaseHistoryLeadStatusChangeProps = {
  historyItem: LeadStatusHistoryLog;
  productClassName: ProductUnion["productClassName"];
};

export default function CaseHistoryLeadStatusChange({ historyItem, productClassName }: CaseHistoryLeadStatusChangeProps) {

  const translatedCurrentStage = _.find(
    getStageList(productClassName),
    (stage) => stage.leadStatus === historyItem.logData.leadStatus.current
  )?.label;
  const translatedPreviousStage = _.find(
    getStageList(productClassName),
    (stage) => stage.leadStatus === historyItem.logData.leadStatus.previous
  )?.label;

  return (
    <GenericLogEntry
      subject={`${translate("historyItem.entityStatusChange.label")}: ${translatedPreviousStage || "Leer"} → ${translatedCurrentStage || "Leer"}`}
      Icon={ArrowRightAlt}
      historyItem={cloneHistoryLogAsGeneric(historyItem)}
    />
  );
};
